import { API_PREFIX } from "./api.constants";

const V1_LEARNING_PATHS_PREFIX = `${API_PREFIX}/learning-paths`;

export const LEARNING_PATH_ENDPOINTS = {
  LEARNING_PATHS: V1_LEARNING_PATHS_PREFIX,
  LEARNING_PATH_DETAIL: (pathId: number | string) => `${V1_LEARNING_PATHS_PREFIX}/${pathId}`,
  LEARNER_VIEW: (pathId: number | string) => `${V1_LEARNING_PATHS_PREFIX}/${pathId}/learner-view`,
  ASSIGN: `${V1_LEARNING_PATHS_PREFIX}/assign`,
  ASSIGNMENTS: (pathId: number | string) => `${V1_LEARNING_PATHS_PREFIX}/${pathId}/assignments`,
  ASSIGN_PREVIEW: (pathId: number | string) => `${V1_LEARNING_PATHS_PREFIX}/${pathId}/assign/preview`,
  DELETE_ASSIGNMENT: (assignmentId: number | string) => `${V1_LEARNING_PATHS_PREFIX}/assignments/${assignmentId}`,
  ASSIGNMENT: (assignmentId: number | string) => `${V1_LEARNING_PATHS_PREFIX}/assignments/${assignmentId}`,
  ASSIGNMENT_UNENROL: (pathId: number | string, assignmentId: number | string) =>
    `${V1_LEARNING_PATHS_PREFIX}/${pathId}/assignments/${assignmentId}/unenrol`,
  ENROLMENT_METHODS: (pathId: number | string) => `${V1_LEARNING_PATHS_PREFIX}/${pathId}/enrolment-methods`,
  ENROLMENT_METHOD: (pathId: number | string, method: string) => `${V1_LEARNING_PATHS_PREFIX}/${pathId}/enrolment-methods/${method}`,
  ENROL: (pathId: number | string) => `${V1_LEARNING_PATHS_PREFIX}/${pathId}/enrol`,
  LEARNERS: (pathId: number | string) => `${V1_LEARNING_PATHS_PREFIX}/${pathId}/learners`,
  LEARNER: (pathId: number | string, userId: number | string) => `${V1_LEARNING_PATHS_PREFIX}/${pathId}/learners/${userId}`,
  LEARNER_SOURCE: (pathId: number | string, userId: number | string, assignmentId: number | string) =>
    `${V1_LEARNING_PATHS_PREFIX}/${pathId}/learners/${userId}/sources/${assignmentId}`,
  LEAVE: (pathId: number | string) => `${V1_LEARNING_PATHS_PREFIX}/${pathId}/leave`,
  REMIND: (pathId: number | string) => `${V1_LEARNING_PATHS_PREFIX}/${pathId}/remind`,
  MY_PROGRESS: `${V1_LEARNING_PATHS_PREFIX}/progress/my`,
  USER_PROGRESS: (userId: number | string) => `${V1_LEARNING_PATHS_PREFIX}/users/${userId}/progress`,
  USER_CYCLES: (userId: number | string, pathId: number | string) => `${V1_LEARNING_PATHS_PREFIX}/users/${userId}/cycles/${pathId}`,
  PROGRAMS_REPORT: `${V1_LEARNING_PATHS_PREFIX}/report`,
  ENROLMENTS_REPORT: `${V1_LEARNING_PATHS_PREFIX}/report/enrolments`,
  CERTIFICATIONS_REPORT: `${V1_LEARNING_PATHS_PREFIX}/report/certifications`,
  MY_REPORT: `${V1_LEARNING_PATHS_PREFIX}/me/report`,
  PROGRAM_CUSTOM_FIELDS: `${V1_LEARNING_PATHS_PREFIX}/cfn/`,
  PROGRAM_CUSTOM_FIELD_DETAIL: (definitionId: number | string) => `${V1_LEARNING_PATHS_PREFIX}/cfn/${definitionId}`,
  RATE: (pathId: number | string) => `${V1_LEARNING_PATHS_PREFIX}/${pathId}/rate`,
  RATINGS: (pathId: number | string) => `${V1_LEARNING_PATHS_PREFIX}/${pathId}/ratings`,
  DELETE_RATING: (pathId: number | string, ratingId: number | string) =>
    `${V1_LEARNING_PATHS_PREFIX}/${pathId}/ratings/${ratingId}`,
  RESOURCES: (pathId: number | string) => `${V1_LEARNING_PATHS_PREFIX}/${pathId}/resources`,
  RESOURCE: (pathId: number | string, resourceId: number | string) =>
    `${V1_LEARNING_PATHS_PREFIX}/${pathId}/resources/${resourceId}`,
};